import SessionDefaults from '@configs/SessionDefaults';
import identityService from '@services/identity.service';
import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { useAuth } from './AuthContext';
const SessionContext = createContext(SessionDefaults);
export const useSessionContext = () => useContext(SessionContext);
export const SessionProvider = ({ children }) => {
    const [identityContext, setIdentityContext] = useState(SessionDefaults.identityContext);
    const { isAuthenticated, isAuthLoading } = useAuth();
    const getIdentityContext = async () => {
        const result = await identityService.getIdentityContext();
        setIdentityContext(result);
    };
    useEffect(() => {
        // Wait for auth loading to complete
        if (isAuthLoading) {
            return;
        }
        // Only load identity context if authenticated
        if (isAuthenticated) {
            getIdentityContext();
        }
    }, [isAuthenticated, isAuthLoading]);
    const values = useMemo(() => ({
        identityContext,
    }), [identityContext]);
    return (<SessionContext.Provider value={values}>
            <>{children}</>
        </SessionContext.Provider>);
};
export default SessionProvider;
